import { DEFAULT_TRANSPORT_METHOD } from 'appConstants';
import useValidations from 'hooks/useValidations';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function useValidationSchema() {
  const { createSchema } = useValidations();
  const { t } = useTranslation('CreateCropOrder', { keyPrefix: 'CustomerDetails.labels' });
  return useMemo(() => {
    const fields = [
      {
        type: 'string',
        label: '',
        ruleName: 'internalOrderId',
      },
      {
        type: 'customer',
        label: t('accountNumber'),
      },
      {
        type: 'representative',
        label: t('representativeAccount'),
      },
      {
        type: 'requiredString',
        ruleName: 'officeLocation',
        label: t('officeLocation'),
      },
      {
        type: 'cropMultiAccount',
        ruleName: 'multiAccount',
        label: t('multiAccount'),
      },
      {
        type: 'requiredString',
        label: t('transportMethod'),
        ruleName: 'transportMethod',
        defaultValue: DEFAULT_TRANSPORT_METHOD,
      },
      {
        type: 'cropDeliveryDate',
        ruleName: 'startDate',
        label: t('deliveryDate'),
      },
      {
        type: 'requiredNumber',
        label: t('deliveryAddress'),
        ruleName: 'addressNumber',
      },
      {
        type: 'string',
        label: t('notes'),
        ruleName: 'customerNotes',
      },
    ];
    return createSchema(fields);
  }, [createSchema, t]);
}
